import { useTranslation } from "react-i18next";

import { Button } from "@components/Form";
import { CustomModal } from "@components/Modals";

const FileSizeLimitModal = ({ isOpened, onSubmit, onToggle, sizeLimit, className = "" }) => {
  const { t } = useTranslation();

  return (
    <CustomModal
      openModal={isOpened}
      setOpenModal={onToggle}
      className={`bg-milk rounded-xl pt-7 pb-8 w-[30vw] ${className}`}
      hideCloseButton
    >
      <div className="flex flex-col items-center">
        <span className="text-center font-bold-poppins text-3xl text-dawn-gray tracking-tight mb-8 px-28">
          {t("modal.sizeLimit.title")}
        </span>
        <p className="text-center text-dawn-gray text-opacity-60 mb-12 px-20">
          {t("modal.sizeLimit.content", { sizeLimit })}
        </p>
        <div className="flex flex-row justify-center items-center gap-x-4 mt-6">
          <Button
            className="py-3 px-16 rounded-full"
            variant="edit"
            onClick={onSubmit}
          >
            <span className="text-white">{t("chat.ok")}</span>
          </Button>
          <Button
            variant="negative"
            className="py-3 px-16 rounded-full"
            onClick={() => onToggle(false)}
          >
            <span className="text-primary">{t("common.cancel")}</span>
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default FileSizeLimitModal;
